<template>
  <div>
    <!-- If I have invitation token in request params-->
    <sign-up-from-invitation-form v-if="invitationToken" />

    <!-- Else display standard form -->
    <sign-up-form
      v-else
      :additional-required-fields="additionalRequiredFields()"
      :show-commercial-offer="commercialOffer()"
      :show-newsletter="newsletter()"
    />
  </div>
</template>

<script>
import SignUpFromInvitationForm from "@/components/partial/SignUpFromInvitationForm";
import SignUpForm from "@/components/partial/SignUpForm";
import {CustomisationMixin} from "@/mixins/CustomisationMixin";

export default {
  name: 'SignUp',
  mixins: [CustomisationMixin],
  components: { SignUpForm, SignUpFromInvitationForm },

  props: {
    hideCommercialOffer: {
      type: Boolean,
      default: false
    },

    hideNewsletter: {
      type: Boolean,
      default: false
    },

    requiredFields: {
      type: String,
      default: null
    },

    // TODO : Delete after widget-options depreciation
    widgetOptions: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      invitationToken: null
    }
  },

  created () {
    let urlParams = new URLSearchParams(window.location.search);
    this.invitationToken = urlParams.get("invitation_token");
  },

  methods: {
    additionalRequiredFields () {
      if (this.customisation && this.customisation.additionalRequiredFields !== undefined) {
        return this.customisation.additionalRequiredFields.split(',');
      } else if (this.requiredFields !== null) {
        return this.requiredFields.split(',');
      } else {
        return []
      }
    },

    commercialOffer () {
      if (this.customisation && this.customisation.commercialOffer !== undefined) {
        return this.customisation.commercialOffer;
      } else {
        return !this.hideCommercialOffer;
      }
    },

    newsletter () {
      if (this.customisation && this.customisation.newsletter !== undefined) {
        return this.customisation.newsletter;
      } else if (this.hideNewsletter === true) {
        return !this.hideNewsletter;
      } else {
        return true;
      }
    }
  }
}
</script>
